export default __webpack_public_path__ + "static/media/python.6a5cbc31.png";